/**
 * Cadastro de clientes da agência.
 *
 * O campo `cronogramaListName` deve ser o nome exato da lista no Trello.
 */
export const clients = [
  {
    name: "Advogado Guilherme Geraldi",
    boardId: "69c2d6fe47261d2701540034",
    cronogramaListName: "Cronograma",
  },
  {
    name: "Agro Solucione",
    boardId: "68a36949bfc43c3f8a01454c",
    cronogramaListName: "Cronograma",
  },
  {
    name: "BK Texas Country",
    boardId: "690d02da182c33e9e922bda6",
    cronogramaListName: "Cronograma",
  },
  {
    name: "Box Livros",
    boardId: "690d01f350d43c866c7c9ad6",
    cronogramaListName: "Cronograma",
  },
  {
    name: "Engenheiro Kessy Bueno",
    boardId: "66c506174a619359441e9acc",
    cronogramaListName: "Cronograma",
  },
  {
    name: "Designer de Interiores Vanessa Volpato",
    boardId: "697278122704f6c3d914b68e",
    cronogramaListName: "Cronograma",
  },
  {
    name: "LLUMI",
    boardId: "69891138616041a2c5c26139",
    cronogramaListName: "Cronograma",
  },
  {
    name: "Victória Rafaelli",
    boardId: "663c1784f16ab2e498ce102f",
    cronogramaListName: "Cronograma",
  },
  {
    name: "Matheus Volpato",
    boardId: "68b769a1e65504385e550c42",
    cronogramaListName: "Cronograma",
  },
]
